import type { IOption } from "@components/ui-kit";
import { t } from "@lingui/macro";
import { ContractTypeEnum } from "@src/__generated__/urql-graphql";
import { map } from "lodash";
import { makeObservable, observable } from "mobx";
import type { ContractModel } from "../../models";
import { FormContract } from "./FormContract";

export enum RelatedTo {
  Client = "client",
  Brand = "brand",
  Projects = "projects",
  Contractor = "contractor",
}

export class StoreContractForm {
  @observable.ref form = new FormContract();

  @observable.ref typeOptions: IOption[] = [
    {
      label: t`Copyright treaty`,
      value: ContractTypeEnum.CopyrightTreaty,
    },
    {
      label: t`Master agreement`,
      value: ContractTypeEnum.MasterAgreement,
    },
    {
      label: t`Nda`,
      value: ContractTypeEnum.Nda,
    },
    {
      label: t`Other`,
      value: ContractTypeEnum.Other,
    },
    {
      label: t`Works contract`,
      value: ContractTypeEnum.WorksContract,
    },
  ];
  @observable.ref contractorOptions: IOption[] = [];
  @observable.ref brandOptions: IOption[] = [];
  @observable.ref projectOptions: IOption[] = [];
  @observable.ref clientOptions: IOption[] = [];
  @observable.ref relatedToOptions: IOption[] = [
    { label: t`Client`, value: RelatedTo.Client },
    { label: t`Brand`, value: RelatedTo.Brand },
    { label: t`Contractor`, value: RelatedTo.Contractor },
    { label: t`Projects`, value: RelatedTo.Projects },
  ];

  constructor() {
    makeObservable(this);
  }

  fillContractForm(contract: ContractModel) {
    this.form.title.onChange(contract.title);
    this.form.valid_from.onChange(contract.validFrom);
    this.form.valid_to.onChange(contract.validTo);
    this.form.valid_to_indefinite.onChange(!contract.validTo);
    this.form.type.onChange(contract.type);
    this.form.project_ids.onChange(map(contract.projects, (p) => p.id));
    this.form.client_id.onChange(contract.clients?.[0]?.id);
    this.form.brand_id.onChange(contract.brands?.[0]?.id);
    this.form.contractor_id.onChange(contract.contractors?.[0]?.id);
    if (contract.brands.length) {
      this.form.related_to.onChange(RelatedTo.Brand);
    }
    if (contract.clients.length) {
      this.form.related_to.onChange(RelatedTo.Client);
    }
    if (contract.contractors.length) {
      this.form.related_to.onChange(RelatedTo.Contractor);
    }
    if (contract.projects.length) {
      this.form.related_to.onChange(RelatedTo.Projects);
    }

    this.form.files.onChange(contract.files);
  }

  static create() {
    return new StoreContractForm();
  }
}
